import { use, isDef } from '../utils';
import Tag from '../tag';

var _use = use('card'),
    sfc = _use[0],
    bem = _use[1];

export default sfc({
  props: {
    tag: String,
    desc: String,
    thumb: String,
    title: String,
    centered: Boolean,
    lazyLoad: Boolean,
    thumbLink: String,
    num: [Number, String],
    price: [Number, String],
    originPrice: [Number, String],
    currency: {
      type: String,
      default: '¥'
    }
  },
  render: function render(h) {
    var thumb = this.thumb,
        slots = this.$slots;
    var Thumb = (slots.thumb || thumb) && h("a", {
      "attrs": {
        "href": this.thumbLink
      },
      "class": bem('thumb')
    }, [slots.thumb || (this.lazyLoad ? h("img", {
      "class": bem('img'),
      "directives": [{
        name: "lazy",
        value: thumb
      }]
    }) : h("img", {
      "class": bem('img'),
      "attrs": {
        "src": thumb
      }
    })), "\n        ", this.tag && h(Tag, {
      "attrs": {
        "mark": true,
        "type": "danger"
      },
      "class": bem('tag')
    }, [this.tag])]);
    var Title = slots.title || this.title && h("div", {
      "class": bem('title')
    }, [this.title]);
    var Desc = slots.desc || this.desc && h("div", {
      "class": [bem('desc'), 'van-ellipsis']
    }, [this.desc]);
    var Price = (slots.price || isDef(this.price)) && h("div", {
      "class": bem('price')
    }, [slots.price || this.currency + " " + this.price]);
    var OriginPrice = isDef(this.originPrice) && h("div", {
      "class": bem('origin-price')
    }, [this.currency + " " + this.originPrice]);
    var Num = (slots.num || isDef(this.num)) && h("div", {
      "class": bem('num')
    }, [slots.num || "x " + this.num]);
    var Footer = slots.footer && h("div", {
      "class": bem('footer')
    }, [slots.footer]);
    return h("div", {
      "class": bem()
    }, [h("div", {
      "class": bem('header')
    }, [Thumb, "\n          ", h("div", {
      "class": bem('content')
    }, [Title, "\n            ", Desc, "\n            ", slots.tags, "\n            ", h("div", {
      "class": "van-card__bottom"
    }, [Price, "\n              ", OriginPrice, "\n              ", Num])])]), "\n        ", Footer]);
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@1.5.2@vant/es/card/index.js
// module id = null
// module chunks = 